import type { Canteiro } from "@/features/canteiros/types.ts";
import { useActiveContext } from "@/store/use-active-context.ts";
import { useCanteiros } from "./use-canteiros.ts";

export function useActiveCanteiro() {
	const query = useCanteiros();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	const canteiros = query.data ?? [];
	const canteiro: Canteiro | null =
		canteiros.find((c) => c.id === activeCanteiroId) ?? null;

	return {
		canteiro,
		canteiros,
		isLoading: query.isPending,
		isError: query.isError,
		refetch: query.refetch,
	};
}
